export default {
  name: 'freeProducts',
  component(props) {
    const { productIds, productThreshold } = props

    return {
      discountSession: {} as { utmKey: string; variantId: string; threshold: number; discountKitTitle: string },
      showNoFreeGift: false,
      // Prevent multiple concurrent add operations
      isUpdatingCart: false,
      // Keep a stable reference to the bound event handler so we can remove it
      onCartUpdateHandler: undefined as unknown as (e: Event) => void,

      removeFreeProduct(cart) {
        const items = cart.items
        if (cart.items_subtotal_price < productThreshold * 100) {
          const discountedCartItem = items.find((item) => {
            if (item?.properties?._dk_gift) return false
            return (
              ((item.final_price === 0 && item.properties._discount_kit !== 'utm') ||
                item.properties._discount_kit === 'free') &&
              productIds.includes(item.product_id)
            )
          })
          if (discountedCartItem) window.liquidAjaxCart.change({ id: discountedCartItem.key, quantity: 0 })
        } else if (!productIds?.length) {
          const discountedCartItem = items.find((item) => {
            if (item?.properties?._dk_gift) return false
            return (
              (item.final_price === 0 && item.properties._discount_kit !== 'utm') ||
              item.properties._discount_kit === 'free'
            )
          })
          if (discountedCartItem) window.liquidAjaxCart.change({ id: discountedCartItem.key, quantity: 0 })
        }
      },

      async init() {
        if (!productIds?.length) {
          this.removeFreeProduct(window.liquidAjaxCart.cart)
        }
        this.onCartUpdateHandler = this.onCartUpdate.bind(this)
        document.addEventListener('liquid-ajax-cart:request-end', this.onCartUpdateHandler)

        this.discountSession = JSON.parse(sessionStorage.getItem('UTM_discount') || '{}')

        if (this.discountSession?.discountKitTitle) {
          await fetch('/cart/update.js', {
            method: 'POST',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: this.discountSession?.discountKitTitle })
          })
        }
      },

      destroy() {
        document.removeEventListener('liquid-ajax-cart:request-end', this.onCartUpdateHandler)
      },

      async onCartUpdate() {
        const response = await fetch('/cart.js')
        const cart = await response.json()
        this.removeFreeProduct(cart)

        this.discountSession = JSON.parse(sessionStorage.getItem('UTM_discount') || '{}')

        if (this.discountSession?.utmKey && this.discountSession?.variantId && this.discountSession?.threshold) {
          // Check if there's already a UTM discount product
          const hasUtmProduct = cart.items.some((item) => item.properties?._discount_kit === 'utm')
          const nonUtmItems = cart.items.filter((item) => !(item.properties?._discount_kit === 'utm'))
          const cartItemsSubtotalPrice = nonUtmItems.reduce((sum, item) => sum + item.final_line_price, 0)

          if (cartItemsSubtotalPrice >= this.discountSession?.threshold * 100) {
            if (hasUtmProduct || this.isUpdatingCart) return

            this.isUpdatingCart = true
            try {
              await this.addFreeProduct(this.discountSession?.variantId, 'utm')
            } catch (error) {
              console.error('[freeProducts]: Error adding UTM discount product', error)
            } finally {
              this.isUpdatingCart = false
            }
          } else {
            try {
              // Remove any UTM discount products if below threshold
              const utmItems = cart.items.filter((item) => item.properties?._discount_kit === 'utm')

              this.isUpdatingCart = true
              utmItems.forEach(async (item) => {
                await window.liquidAjaxCart.change({ id: item.key, quantity: 0 })
              })
            } catch (error) {
              console.error('[freeProducts]: Error removing UTM discount products', error)
            } finally {
              this.isUpdatingCart = false
            }
          }
        }
      },

      async addFreeProduct(variantId, properties) {
        await window.liquidAjaxCart.add({
          items: [
            {
              id: variantId,
              quantity: 1,
              price: 0,
              properties: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                _discount_kit: properties
              }
            }
          ]
        })
      },

      selectFreeProduct(variantId) {
        const items = window.liquidAjaxCart.cart.items
        const discountedCartItem = items.find((item) => {
          return (
            (item.final_price === 0 ||
              item.properties._discount_kit === 'free' ||
              Boolean(item?.properties?._dk_gift)) &&
            productIds.includes(item.product_id)
          )
        })

        if (discountedCartItem && discountedCartItem.variant_id !== variantId && variantId !== 'none') {
          window.liquidAjaxCart.change({ id: discountedCartItem.key, quantity: 0 })
          this.addFreeProduct(variantId, 'free')
          sessionStorage.setItem('showNoFreeGift', 'false')
        } else if (!discountedCartItem && variantId !== 'none') {
          this.addFreeProduct(variantId, 'free')
          sessionStorage.setItem('showNoFreeGift', 'false')
        } else if (variantId === 'none') {
          sessionStorage.setItem('showNoFreeGift', 'true')
          if (discountedCartItem) window.liquidAjaxCart.change({ id: discountedCartItem.key, quantity: 0 })
        }
      }
    }
  }
}
